import React, { Component } from 'react';

import {connect} from 'react-redux';
import {reduxForm} from 'redux-form';

import { Grid, Modal } from '@material-ui/core';
import { Button } from '@material-ui/core';
import { InputAdornment } from '@material-ui/core';
import { ClearRounded, SearchRounded } from '@material-ui/icons';
import { Paper } from '@material-ui/core';
import { TextField } from '@material-ui/core';
import { IconButton } from '@material-ui/core';


export class LIconsModal extends Component {
    constructor(props){
        super(props)
        
        this.state={
            IconsArr:[],
            selected:undefined,
            search:''        
        }

       
    };
    componentDidMount(){

      if(this.props.icons){
          let icons=this.props.icons.slice(0,100);
          this.setState({IconsArr:icons})
      }
      if(this.props.iconSelected){
          this.setState({selected:this.props.iconSelected});
      }
    }


    handleSelectIcon=(icon)=>{
        this.setState({selected: icon},
            () =>{
                if(icon){
                    this.props.onSelectIcon(icon)
                }
            }
        )      
    }

    saveSearch=(value)=>{
        this.setState({search:value});
    }

    SearchIcon=()=>{
        const value=this.state.search.toLowerCase();

        if(value!==undefined && value !==''){
                        
            const icons=this.props.icons?this.props.icons:[]

            const iconsFilered = icons.filter(element => {
                
                var existTag = element.tags.find(tag=>tag.includes(value))
                return existTag;
            });
    
            this.setState({IconsArr:iconsFilered});
        }
    };

    ClearSearch=()=>{
        let icons=this.props.icons.slice(0,100);
        this.setState({IconsArr:icons, search:''});
    }

    render() {

        return(
            <>
                <Modal 
                 open={true}
                 onClose={() => this.props.onClose()}
                >
                    <Paper  elevation={3}>
                        <Grid className="LIconsModal" id='icons_modal'>
                            <Grid className="ModalTitle">Select an Icon</Grid>
                            <Grid xs={12} className="searchIconComponent" direction='row' alignItems='center' justify='space-between'>
                                <TextField
                                    id='icons_modal_search'
                                    item 
                                    name='Search'
                                    placeholder='Search'
                                    value={this.state.search}
                                    InputProps={{
                                        startAdornment:(
                                            <InputAdornment position="start">
                                                <SearchRounded style={{color:'white', fontSize:30}} />
                                            </InputAdornment>
                                        ),
                                        endAdornment:(
                                          <InputAdornment position="end">
                                                <IconButton id='icons_modal_clear_btn' onClick={this.ClearSearch}>
                                                    <ClearRounded style={{color:'white', fontSize:30}} />
                                                </IconButton>
                                          </InputAdornment>  
                                        )
                                    }}
                                    className="searchInput"
                                    onChange={(e)=>this.saveSearch(e.target.value)}
                                    onKeyDown={(e)=>{if(e && e.keyCode && e.keyCode=== 13){this.SearchIcon()}}}
                                />
                                <Button id='icons_modal_search_btn' item variant='contained' className="btnSearch" onClick={this.SearchIcon}>Search</Button>
                            </Grid>
                                

                
                            <Grid container xs={12} justify='flex-start' id='icons_modal_container' direction='row' className="iconsContainer">
                                {
                                    this.state.IconsArr && this.state.IconsArr.map((item)=>{
                                        let legacyUrl = item.iconUrl.replace('/Categories', '/Categories_Legacy');
                                        return(
                                            <Grid item container direction='column' alignItems='center' justify='center' 
                                                className="iconCard" xs={12} sm={12} md={3} lg={2}
                                                onClick={()=>this.handleSelectIcon(item)}
                                                id={`icon_${item._id}`}
                                            >
                                                <img
                                                    item
                                                    src={legacyUrl}
                                                    alt='icon'
                                                    className="ListIcon_Legacy"
                                                />
                                                <Grid item className="LiconName">{item.name}</Grid>    
                                            </Grid>
                                        )
                                    })
                                }
                            </Grid>
                    
                        </Grid>
                    </Paper>
                   
                </Modal>
               
            </>
        )
    }
}

function mapStateToProps(state){
    const IconsData = (state.categoryReducer && state.categoryReducer.IconsData)  ? state.categoryReducer.IconsData : [];
    return{
        IconsData: IconsData
    };
}


export default connect(mapStateToProps,{})(reduxForm({
    form: 'SearchIconsForm',
})(LIconsModal));

